$(document).ready(function () {
  if ($(window).width() <= 768) {
    $(".js-product-compare-list").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      prevArrow: $(".block__product-compare-slider-btn-prev"),
      nextArrow: $(".block__product-compare-slider-btn-next"),
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    });

    $(".js-video_info-inner-slider").slick({
      slidesToShow: 2.5,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      accessibility: false,
    });
  }

  $(document).on("click", ".block__video-info-icon-play", function () {
    var $this = $(this);
    $this.addClass("hide");
    $this.parents(".block_video_info-inner-box-inner").find("video")[0].play();
    $this.parents(".block_video_info-inner-box-inner").find("video").attr("controls", true);
  });

  $(".faq_acc").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).find(".faq_acc_content").slideUp();
      $(this).removeClass("active");
    } else {
      $(".faq_acc_content").slideUp();
      $(".faq_acc").removeClass("active");
      $(this).find(".faq_acc_content").slideToggle();
      $(this).toggleClass("active");
    }
  });

  $('.feature_collection_slider').slick({
    slidesToShow: 5,
    slidesToScroll: 3,
    arrows: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  if ($(window).width() <= 749) {
    $('.article_custom_product').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      responsive: [
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 360,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  $(".article_custom_nav_mobile").click(function(){
    $(this).parent(".article_custom_nav_mobile_main").find("ul").slideToggle();
  });
  $(".article_custom_nav_menu_mo li").click(function(){
    $(this).parent("ul").slideToggle();
  });

  $('.block_collection-list-slider').slick({
    slidesToShow: 6,
    slidesToScroll: 3,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2
        }
      }
    ]
  });

  $(document).on("click",".block__plants-type-list-single",function(){
    var $this = $(this);
    var data_id = $this.attr("data_id");
    $(".block__plants-type-list").removeClass("active");
    $this.parents(".block__plants-type-list").addClass("active");

    var offset_top = $(".block__plants-type-box-content#block_"+data_id).offset().top;
    $("html, body").animate({scrollTop:offset_top},"slow")
  });

  $(document).on("click",".block__mobile-filter-box",function(){
    $(".block__plants-type-list-box").toggleClass("active");
  });

  if($('.block__product-sticky-bar-section').length){
    $(window).on('scroll',function(){
      var topHeight = $('.product-single__meta .shopify-product-form').offset().top+$('.product-single__meta .shopify-product-form').outerHeight();
      if ($(this).scrollTop() >= topHeight){
        $('.block__product-sticky-bar-section').removeClass("hide")
      }else{
        $('.block__product-sticky-bar-section').addClass("hide");
      }
    });
  }

  $(document).on("click",".block__product-compare-list-add-to-cart",function(e){
  e.preventDefault();
    var $this = $(this);
    $this.addClass("btn--loading");
    var serialize = $(this).parents("form").serialize();
    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      dataType: 'json',
      data: serialize,
      success:function(data) {
        document.dispatchEvent(new CustomEvent('cart:build'));
        $.getJSON('/cart.js',function(cart){
          if(cart.item_count > 0) {
            $(".cart-link__bubble").addClass('cart-link__bubble--visible');
            $('.cart-link__bubble-num').text(cart.item_count);
          } else {
            $(".cart-link__bubble").removeClass('cart-link__bubble--visible');
            $('.cart-link__bubble-num').text(cart.item_count);
          }
        });
        $this.removeClass("btn--loading");
        setTimeout(function() {
          $("#HeaderCartTrigger")[0].click();
        }, 2000);
      },
      error: function (error) {
        alert(error.responseJSON.description);
      }
    });
  });
});

var videos = document.querySelectorAll('.block_video_info-inner-video video');
videos.forEach(function(video) {
    video.addEventListener('play', function() {
        videos.forEach(function(otherVideo) {
            if (otherVideo !== video) {
                otherVideo.pause();
            }
        });
    });
});




